import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bsStyle", "className", "iconLeft", "title", "headerClassName", "titleClassName", "bodyClassName", "mountOnEnter", "unmountOnExit", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "children", "onToggle", "open"];
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from '../collapse/Collapse';
import classNames from 'classnames';
var ExpanderPanel = function ExpanderPanel(props) {
  var bsStyle = props.bsStyle,
    className = props.className,
    iconLeft = props.iconLeft,
    title = props.title,
    headerClassName = props.headerClassName,
    titleClassName = props.titleClassName,
    bodyClassName = props.bodyClassName,
    mountOnEnter = props.mountOnEnter,
    unmountOnExit = props.unmountOnExit,
    onEnter = props.onEnter,
    onEntering = props.onEntering,
    onEntered = props.onEntered,
    onExit = props.onExit,
    onExiting = props.onExiting,
    onExited = props.onExited,
    children = props.children,
    onToggle = props.onToggle,
    open = props.open,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];

  // Update internal state from external prop change
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  var handleToggle = function handleToggle() {
    var newState = !isOpen;
    setIsOpen(newState);
    onToggle(newState);
  };
  var wrapperClassNames = classNames('expander-panel panel', "panel-".concat(bsStyle), className);
  var iconClassNames = classNames('expander-icon', 'rioglyph', 'rioglyph-chevron-down');
  var headerClassNames = classNames('panel-heading', isOpen && 'open', iconLeft && 'icon-left', headerClassName && headerClassName);
  var titleClassNames = classNames('title', titleClassName && titleClassName);
  var bodyClassNames = classNames('panel-body', bodyClassName && bodyClassName);
  var isRenderCallback = children && typeof children === 'function';
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: wrapperClassNames
  }), /*#__PURE__*/React.createElement("div", {
    className: headerClassNames,
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement("span", {
    className: titleClassNames
  }, title), /*#__PURE__*/React.createElement("span", {
    className: iconClassNames
  }), bsStyle === 'separator' && /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }, /*#__PURE__*/React.createElement("hr", null))), /*#__PURE__*/React.createElement(Collapse, {
    "in": isOpen,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: bodyClassNames
  }, isRenderCallback ? children(isOpen) : children))));
};
ExpanderPanel.defaultProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  bsStyle: 'blank',
  iconLeft: false,
  open: false,
  onToggle: function onToggle() {},
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {}
};
ExpanderPanel.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  bsStyle: PropTypes.oneOf(['blank', 'default', 'separator', 'primary', 'secondary', 'info', 'warning', 'danger', 'success']),
  iconLeft: PropTypes.bool,
  open: PropTypes.bool,
  mountOnEnter: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  onToggle: PropTypes.func,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};
export default ExpanderPanel;